import { combineReducers } from 'redux'
import auth from './auth'
import navbar from './navbar'
import layout from './layout'
import categories from './categories'
import users from './users'
import announcements from './announcements'

const rootReducer = combineReducers({
  auth,
  navbar,
  layout,
  categories,
  users,
  announcements,
})

export default rootReducer
